module.exports = __webpack_public_path__ + "static/media/santa-monica.50f09e97.png";